@if (facade.isLoading()) {
<div class="d-flex h-100 justify-content-center align-items-center">
  <av-loading-item icon="bar_chart" textKey="app.reports.anomalies.loading" />
</div>
} @else {
<div class="reports-page px-2 pt-3 pb-2">

  <div class="d-flex justify-content-end mb-3">
    <button mat-flat-button color="primary" (click)="exportAllCsv()">
      <mat-icon>download</mat-icon>
      {{ 'app.reports.anomalies.export_all_csv' | translate }}
    </button>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-12 col-lg-4">
      <div class="health-score-hero d-flex flex-column align-items-center justify-content-center h-100">
        <span class="hero-label">{{ 'app.reports.dashboard.health_score' | translate }}</span>
        @if (facade.healthScore() !== null) {
        <div echarts class="health-gauge" [options]="healthGaugeOptions()!"></div>
        } @else {
        <span class="health-score-empty">{{ emDash }}</span>
        <span class="health-score-caption">{{ 'app.reports.dashboard.health_score_empty' | translate }}</span>
        }
      </div>
    </div>
    <div class="col-12 col-lg-8">
      <div class="row g-3">
        @for (tile of tiles(); track tile.key) {
        <div class="col-12 col-sm-6 col-xl-3">
          <app-report-kpi-tile [icon]="tile.icon" [labelKey]="tile.titleKey" [value]="tile.count"
            [percent]="tile.percent" [severity]="tile.severity" (tileClick)="openSection(tile.key)" />
        </div>
        }
      </div>
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-12 col-lg-6">
      <app-report-chart-card titleKey="app.reports.dashboard.compliance_donut_title"
        [options]="complianceDonutOptions()" (segmentClick)="openSection($event)" />
    </div>
    <div class="col-12 col-lg-6">
      <app-report-chart-card titleKey="app.reports.dashboard.category_bar_title"
        [options]="categoryBarOptions()" (segmentClick)="openSection($event)" />
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-12 col-lg-6">
      <app-report-chart-card titleKey="app.reports.dashboard.os_edition_donut_title"
        [options]="osEditionDonutOptions()" (segmentClick)="openSection($event)" />
    </div>
    <div class="col-12 col-lg-6">
      <app-report-chart-card titleKey="app.reports.anomalies.app_failure"
        [options]="topFailingAppsBarOptions()" (segmentClick)="openSection($event)" />
    </div>
  </div>

  <div class="row g-3">
    <div class="col-12">
      <div class="at-risk-widget">
        <div class="at-risk-header d-flex justify-content-between align-items-center">
          <span class="at-risk-title">{{ 'app.reports.dashboard.at_risk.title' | translate }}</span>
          <button mat-stroked-button (click)="openSection(atRiskSection.key)">
            {{ 'app.reports.dashboard.view_all' | translate }}
          </button>
        </div>
        @if (facade.topAtRiskDevices().length > 0) {
        <div class="at-risk-list">
          @for (entry of facade.topAtRiskDevices(); track entry.deviceName) {
          <div class="at-risk-row d-flex align-items-center" (click)="openSection(atRiskSection.key)">
            <span class="at-risk-device flex-grow-1">{{ entry.deviceName }}</span>
            <span class="at-risk-penalty">{{ entry.penalty }}</span>
            <mat-chip-set class="at-risk-chips">
              @for (membership of entry.memberships; track membership) {
              <mat-chip>{{ membershipTitleKey(membership) | translate }}</mat-chip>
              }
            </mat-chip-set>
          </div>
          }
        </div>
        } @else {
        <div class="at-risk-empty d-flex align-items-center justify-content-center">
          <span>{{ 'app.reports.dashboard.at_risk.empty' | translate }}</span>
        </div>
        }
      </div>
    </div>
  </div>

</div>
}
